import PropTypes from 'prop-types'
import React from 'react'
import styles from './_myRouteResults.css'
import { FormattedDistance } from 'shared/units'
import { FormattedElevation } from 'shared/units'
import { FormattedMessage, FormattedDate } from 'react-intl'
import classnames from 'classnames'
import Svg from 'components/util/Svg'
import Loader from 'components/util/Loader'

export default function MyRouteResults (props) {
  const {
    routes,
    loading,
    deleteRouteAction,
    notFoundComponent,
    sortByDateAction,
    sortByDistanceAction,
    removeBookmarkAction,
    orderBy,
    bookmarkView,
  } = props

  const searchingDistance = (orderBy === 'distance' || orderBy === '-distance')
  const searchingDate = (orderBy === 'date_created' || orderBy === '-date_created')

  return (
    <section className={styles.resultsContainer}>
      <table className={styles.tableContainer}>
        <thead>
          <tr>
            <th className={styles.thumbnailCell}>
              <FormattedMessage id='myroutes.table.route' defaultMessage='Route' />
            </th>
            <th className={!bookmarkView ? styles.sortableCell : null} onClick={sortByDateAction}>
              <FormattedMessage id='myroutes.table.created' defaultMessage='Created' />
              {searchingDate ?
                <Svg name='select_down' className={classnames(styles.dateArrow, {
                  [styles.dateArrowUp]: (orderBy === '-date_created'),
                })} /> : null}
            </th>
            <th className={!bookmarkView ? styles.sortableCell : null} onClick={sortByDistanceAction}>
              <FormattedMessage id='myroutes.table.distance' defaultMessage='Distance' />
              {searchingDistance ?
                <Svg name='select_down' className={classnames(styles.dateArrow, {
                  [styles.dateArrowUp]: (orderBy === '-distance'),
                })} /> : null}
            </th>
            <th><FormattedMessage id='myroutes.table.elevation' defaultMessage='Elevation' /></th>
            <th><FormattedMessage id='myroutes.table.name' defaultMessage='Name' /></th>
            <th><FormattedMessage id='myroutes.table.city' defaultMessage='City' /></th>
            <th className={styles.privacyCell}>
              <FormattedMessage id='myroutes.table.privacy' defaultMessage='Privacy' />
            </th>
            <th><FormattedMessage id='myroutes.table.options' defaultMessage='Options' /></th>
          </tr>
        </thead>
        {routes && routes.length ?
          <tbody>
            {routes.map((route, i) => {
              const routeId = route._links.self[0].id
              const privacyIconClass = `privacyIcon--${route._links.privacy[0].id}`

              return (<tr key={i}>
                <td className={styles.thumbnailCell}>
                  <a href={`/routes/view/${routeId}`}>
                    <img className={styles.thumbnail} src={route._links.thumbnail[0].href} />
                  </a>
                </td>
                <td>
                  <a href={`/routes/view/${routeId}`}>
                    <FormattedDate value={route.created_datetime} />
                  </a>
                </td>
                <td><FormattedDistance value={route.distance} digits={2} /></td>
                <td className={styles.elevationCell}><FormattedElevation value={route.total_ascent} /></td>
                <td>
                  <a href={`/routes/view/${routeId}`}>
                    {route.name}
                  </a>
                </td>
                <td>{route.city}</td>
                <td className={styles.privacyCell}>
                  <div className={classnames(styles.privacyIcon, styles[privacyIconClass])} />
                </td>
                <td>
                  <a className={styles.optionsLink} href={`/routes/copy/${routeId}`}>
                    <FormattedMessage id='myroutes.table.copy' defaultMessage='Copy' />
                  </a>

                  {!bookmarkView ?
                    <a className={styles.optionsLink} href={`/routes/edit/${routeId}`}>
                      <FormattedMessage id='myroutes.table.edit' defaultMessage='Edit' />
                    </a> : null}

                  {!bookmarkView ?
                    <a onClick={() => deleteRouteAction(routeId)} className={styles.optionsLink}>
                      <FormattedMessage id='myroutes.table.delete' defaultMessage='Delete' />
                    </a> : null }

                  {bookmarkView ?
                    <a
                      onClick={() => removeBookmarkAction(route._links.bookmark[0].id)}
                      className={styles.optionsLink}>
                      <FormattedMessage id='myroutes.table.remove' defaultMessage='Remove' />
                    </a> : null }
                </td>
              </tr>)
            })}
          </tbody> : null}
      </table>
      {!loading && routes && !routes.length ?
        <div>{notFoundComponent}</div> : null}

      {loading ?
        <div className={styles.loadingOverlay}>
          <Loader type='spin' height={60} width={60} />
        </div> : null}
    </section>
  )
}

MyRouteResults.propTypes = {
  routes: PropTypes.array,
  loading: PropTypes.bool,
  deleteRouteAction: PropTypes.func,
  notFoundComponent: PropTypes.node,
  sortByDateAction: PropTypes.func,
  sortByDistanceAction: PropTypes.func,
  removeBookmarkAction: PropTypes.func,
  orderBy: PropTypes.string,
  bookmarkView: PropTypes.bool,
}

MyRouteResults.defaultProps = {
  sortByDistanceAction: function () {},
  sortByDateAction: function () {},
  removeBookmarkAction: function () {},
  orderBy: null,
  bookmarkView: false,
}
